<template>
  <div class="homepage-2">
    <ScrollupSection />
    <div class="main">
      <HeaderSection />
      <HeroSection/>
      <FeatureSection />
      <DiscoverSection />
      <WorkSection />
      <PricingSection :data="pricing" />
      <FooterSection />
    </div>
  </div>
</template>

<script>
import ScrollupSection from '../components/ScrollupSection/scrollUp'
import HeaderSection from '../components/HeaderSection/headerOne'
import HeroSection from '../components/HeroSection/heroWeb'
import FeatureSection from '../components/FeatureSection/featureTwo'
import DiscoverSection from '../components/DiscoverSection/discoverTwo'
import WorkSection from '../components/WorkSection/work'
import PricingSection from '../components/PricingSection/pricing'
import FooterSection from '../components/FooterSection/footerOne'

export default {
  name: 'PageTurnkeyWeb',
  components: {
    ScrollupSection,
    HeaderSection,
    HeroSection,
    FeatureSection,
    DiscoverSection,
    WorkSection,
    PricingSection,
    FooterSection
  },
  data () {
    return {
      pricing: {
        title: 'Get Started Today',
        text: 'Choose the normal (FREE) plan, or independent plan, which lets you use our platform in specific or sensitive settings, like education, legal or medical industries.',
        gray: true,
        plans: [{
          name: 'Free',
          price: '0',
          id: 'TURNKEY-WEB-FREE',
          features: [
            'Unlimited Content',
            'Unlimited Views',
            'Unlimited Tracked Events',
            'Unlimited Users',
            'Unlimited Engagements',
            'Email Support',
            'Smart content required'
          ]
        },
        {
          name: 'Independent',
          price: '0.00001',
          id: 'TURNKEY-WEB-PRO',
          features: [
            'Unlimited Content',
            'Unlimited Views',
            'Unlimited Tracked Events',
            'Unlimited Users',
            'Unlimited Engagements',
            'Unlimited 24/7 Support',
            'Only smart content you create'
          ]
        }]
      }
    }
  }
}
</script>

<style>

</style>